import { Box, Stack, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { calcularRepasse, emReais } from '../global/repasse';

const LARANJA_FUNDO = '#fff8e1';
const LARANJA_BORDA = '#ffe0b2';
const LARANJA_TEXTO = '#8a5a00';

/**
 * Aviso de quanto sobra para o anfitriao pelo preco que ele digitou.
 *
 * Vive APENAS na tela de criacao de encontro (NewMeeting), logo abaixo do campo
 * de preco. E onde a decisao de preco acontece; repetir em outras telas so
 * polui. Nao replicar sem pedido explicito.
 *
 * As taxas da Empiria sao exatas; a do Pagar.me e estimativa, porque a
 * aliquota real depende da forma de pagamento e do parcelamento.
 */
export default ({ preco, gratuito }) => {
    const { rules } = useAuth();

    if (gratuito) return null;

    const repasse = calcularRepasse(preco, rules);

    // Aviso previo de 30 dias para mudanca da Taxa de Intermediacao (item 4.4
    // da Politica Geral de Compra e Pagamento). Enquanto a data nao chega, a
    // venda continua saindo pela taxa atual - e o anfitriao ja sabe o que vem.
    const taxaAgendada =
        rules?.pending_empiria_fee !== null && rules?.pending_empiria_fee !== undefined && rules?.pending_fee_at
            ? {
                  percentual: Number(rules.pending_empiria_fee),
                  quando: new Date(rules.pending_fee_at).toLocaleDateString('pt-BR'),
              }
            : null;

    const Linha = ({ rotulo, valor, destaque }) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography sx={{ fontSize: '0.7rem', color: LARANJA_TEXTO, fontWeight: destaque ? 700 : 400 }}>
                {rotulo}
            </Typography>
            <Typography sx={{ fontSize: '0.7rem', color: LARANJA_TEXTO, fontWeight: destaque ? 700 : 400 }}>
                {valor}
            </Typography>
        </Stack>
    );

    return (
        <Box
            sx={{
                mt: 1,
                p: 1.25,
                borderRadius: '10px',
                bgcolor: LARANJA_FUNDO,
                border: `1px solid ${LARANJA_BORDA}`,
            }}
        >
            <Stack spacing={0.35}>
                {/* Preco ainda zerado: o quadro aparece mesmo assim, senao ele
                    so surgiria depois de digitar - justo quando ja nao ajuda a
                    decidir o preco */}
                {!repasse ? (
                    <Typography sx={{ fontSize: '0.7rem', color: LARANJA_TEXTO, lineHeight: 1.4 }}>
                        Informe o valor do encontro para ver quanto fica com você depois das taxas.
                    </Typography>
                ) : repasse.invalido ? (
                    <Typography sx={{ fontSize: '0.7rem', color: '#c62828', fontWeight: 600, lineHeight: 1.4 }}>
                        Com esse preço as taxas consomem todo o valor e você não receberia nada.
                        Aumente o preço do encontro.
                    </Typography>
                ) : (
                    <>
                        <Linha rotulo={`Comissão da Empiria (${repasse.percentual}%)`} valor={`- ${emReais(repasse.comissao)}`} />
                        <Linha rotulo="Custo da chamada" valor={`- ${emReais(repasse.custoChamada)}`} />
                        <Linha rotulo={`Taxa do Pagar.me (~${repasse.percentualPagarme}%)`} valor={`- ${emReais(repasse.taxaPagarme)}`} />

                        <Box sx={{ borderTop: `1px solid ${LARANJA_BORDA}`, my: 0.25 }} />

                        <Linha
                            rotulo="Você recebe (estimado)"
                            valor={`${emReais(repasse.liquido)}  ·  ${repasse.percentualLiquido.toFixed(0)}%`}
                            destaque
                        />

                        <Typography sx={{ fontSize: '0.65rem', color: LARANJA_TEXTO, opacity: 0.85, lineHeight: 1.35, pt: 0.25 }}>
                            A taxa do Pagar.me é uma estimativa: o valor final varia um pouco conforme a
                            forma de pagamento e o parcelamento escolhidos pelo conviva.
                        </Typography>

                        {repasse.liquidoNegativo && (
                            <Typography sx={{ fontSize: '0.65rem', color: '#c62828', fontWeight: 600, lineHeight: 1.35 }}>
                                Com esse preço, a estimativa não deixa nada para você. Considere aumentar o valor.
                            </Typography>
                        )}
                    </>
                )}

                {taxaAgendada && (
                    <>
                        <Box sx={{ borderTop: `1px solid ${LARANJA_BORDA}`, my: 0.25 }} />
                        <Typography sx={{ fontSize: '0.65rem', color: LARANJA_TEXTO, fontWeight: 600, lineHeight: 1.35 }}>
                            A comissão da Empiria passa a ser {taxaAgendada.percentual}% em{' '}
                            {taxaAgendada.quando}. Até lá, e para os encontros já vendidos, vale a taxa
                            atual.
                        </Typography>
                    </>
                )}
            </Stack>
        </Box>
    );
};
